import { scheduleUpdateLatestActivity } from 'src/modules/profile/sagas/utils/scheduleUpdateLatestActivity';
import { emulateTransitionDelay } from 'src/modules/routing/hooks/emulateTransitionDelay';
import { guest } from 'src/modules/routing/hooks/guest';
import { abortProjectList } from 'src/modules/routing/hooks/resolvers/abortProjectList';
import { fetchProjectDetails } from 'src/modules/routing/hooks/resolvers/fetchProjectDetails';
import { fetchProjectList } from 'src/modules/routing/hooks/resolvers/fetchProjectList';
import { fetchReportData } from 'src/modules/routing/hooks/resolvers/fetchReportData';
import { resetEvaluation } from 'src/modules/routing/hooks/resolvers/resetEvaluation';
import { resetProjectDetails } from 'src/modules/routing/hooks/resolvers/resetProjectDetails';
import { resetProjectList } from 'src/modules/routing/hooks/resolvers/resetProjectList';
import { resetReportData } from 'src/modules/routing/hooks/resolvers/resetReportData';
import { resetUsersList } from 'src/modules/routing/hooks/resolvers/resetUsersList';
import { syncProjectDetails } from 'src/modules/routing/hooks/resolvers/syncProjectDetails';
import { createStateTransitionLoggingSaga } from 'src/modules/routing/hooks/stateTransitionLogging';
import { returnToHome } from 'src/modules/routing/sagas/returnToHome';
import { RouteState } from 'src/modules/routing/types/RouteState';
import { composeSagas } from 'src/modules/routing/utils/composeSagas';

export const ROUTING_PROJECT_STATES: ReadonlyArray<RouteState> = [
  {
    url: '/projects',
    name: 'bp:project:list',
    parent: 'bp:authorized',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
      guest,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      abortProjectList,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
      abortProjectList,
      fetchProjectList,
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
      scheduleUpdateLatestActivity,
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetProjectList,
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
      abortProjectList,
      scheduleUpdateLatestActivity,
    ),
  },
  {
    url: '/project/:id([-a-f0-9]+)',
    name: 'bp:project:view',
    parent: 'bp:authorized',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
      fetchProjectDetails,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
      scheduleUpdateLatestActivity,
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetProjectDetails,
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
      scheduleUpdateLatestActivity,
    ),
  },
  {
    url: '',
    name: 'bp:project:basedata',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
  {
    url: '/hvac/settings',
    name: 'bp:project:hvac:settings',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 200),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/hvac/emission',
    name: 'bp:project:hvac:emission',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      returnToHome,
      emulateTransitionDelay(0, 200),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/hvac/distribution',
    name: 'bp:project:hvac:distribution',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      returnToHome,
      emulateTransitionDelay(0, 200),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/hvac/generation',
    name: 'bp:project:hvac:generation',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      returnToHome,
      emulateTransitionDelay(0, 200),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/hvac/results',
    name: 'bp:project:hvac:results',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      returnToHome,
      emulateTransitionDelay(0, 200),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/evaluation',
    name: 'bp:project:evaluation',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetEvaluation,
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/report',
    name: 'bp:project:report',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
      fetchReportData,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
      syncProjectDetails,
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
      fetchReportData,
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetReportData,
      resetUsersList,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },

  {
    url: '/report/document',
    name: 'bp:project:report-document',
    parent: 'bp:project:view',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
      fetchReportData,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
      fetchReportData,
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
    ),
  },
];
